import gql from 'graphql-tag';

export default gql`
mutation DeleteEndpointImage(
        $uuidEndpoint: String!,
        $uuidImage: String!
        ) {
    deleteImage(input:{
        uuidEndpoint: $uuidEndpoint,
        uuidImage: $uuidImage
    }) {
        __typename
        uuid
        images
    }
}
`;
